import React from 'react';
import { labelStyles, LabelProps } from './styles';

const Label24: React.FC<LabelProps> = ({
    children,
    className,
    style,
    isBold,
    isPrimary,
    onClick,
}) => {
    const { label24Styles, primary, bold } = labelStyles();
    const classes = `${className} ${label24Styles} ${
        isPrimary ? primary : ''
    } ${isBold ? bold : ''}`;
    return (
        <div className={classes} style={style} onClick={onClick}>
            {children}
        </div>
    );
};

export default Label24;
